import React, { Component } from "react";
import InputMask from "react-input-mask";

import API from "../../../actions/api-helper";
import DataUtil from "../../../actions/data.js";

import { withRouter } from "react-router-dom";
import UI from "../../../actions/ui-helper";

class Producao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {
        periodoDe: DataUtil.primeiroDiaMes(),
        periodoAte: DataUtil.ultimoDiaMes(),
        profissionalId: this.props.usuario.id,
        tipo: 0,
      },
      usuarios: [],
      resultado: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    UI.loader("show", "Aguarde, buscando profissionais...");
    API.get("/usuarios/ativos").then(
      function (json) {
        // Cria uma lista simplificada de usuários
        //let usuarios = [{ id: 0, nome: "TODOS" }];
        let usuarios = [];
        json.data.forEach((usuario) => {
          usuarios.push({
            id: usuario.id,
            nome: usuario.nome,
          });
        });
        this.setState({ usuarios: usuarios });
        UI.loader("hide");
      }.bind(this)
    );
  }

  handleSubmit(event) {
    event.preventDefault();

    let data = this.state.consulta;
    if (
      !DataUtil.validarData(data.periodoDe) ||
      !DataUtil.validarData(data.periodoAte)
    ) {
      data.periodoDe = DataUtil.primeiroDiaMes();
      data.periodoAte = DataUtil.ultimoDiaMes();
    }

    this.props.history.push("/impressao/producao", this.state.consulta);
  }

  handleChange(event) {
    let consulta = { ...this.state.consulta };
    consulta[event.target.name] = event.target.value;
    this.setState({ consulta: consulta });
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">PRODUÇÃO POR PERÍODO</h4>
                <p className="card-description" />
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label>Período De</label>
                        <InputMask
                          placeholder="PERÍODO DE"
                          name="periodoDe"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.periodoDe}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-md-4">
                        <label>Período Até</label>
                        <InputMask
                          placeholder="PERÍODO ATÉ"
                          name="periodoAte"
                          className="form-control"
                          mask="99/99/9999"
                          value={this.state.consulta.periodoAte}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="col-sm-4">
                        <label>Tipo</label>
                        <select
                          name="tipo"
                          className="form-control"
                          value={this.state.consulta.tipo}
                          onChange={this.handleChange}
                        >
                          <option value={0}>GERAL</option>
                          <option value={1}>ATENDIMENTO</option>
                          <option value={2}>ATIVIDADE / REUNIÃO</option>
                        </select>
                      </div>
                      <div className="col-sm-6" style={{ paddingTop: 10 }}>
                        <label>Profissional</label>
                        <select
                          name="profissionalId"
                          className="form-control"
                          value={this.state.consulta.profissionalId}
                          onChange={this.handleChange}
                        >
                          {this.state.usuarios.map((usuario, i) => {
                            if (
                              this.props.usuario.perfil <= 1 ||
                              this.props.usuario.id === usuario.id
                            ) {
                              return (
                                <option key={usuario.id} value={usuario.id}>
                                  {usuario.nome}
                                </option>
                              );
                            }
                            return null;
                          })}
                        </select>
                      </div>
                      <div className="col-sm-6" style={{ paddingTop: 10 }}>
                        <label>Linha de Cuidado</label>
                        <select
                          name="linhaId"
                          className="form-control"
                          value={this.state.consulta.linhaId}
                          onChange={this.handleChange}
                        >
                          <option value="">
                            Selecione uma linha de cuidado
                          </option>
                          <option value="01">Linha 01 - GESTANTE</option>
                          <option value="02">Linha 02 - CRIANÇA</option>
                          <option value="03">
                            Linha 03 - MATERNO INFANTIL
                          </option>
                          <option value="04">
                            Linha 04 - HIPERTENSÃO ARTERIAL
                          </option>
                          <option value="05">Linha 05 - DIABETES</option>
                          <option value="06">Linha 06 - IDOSO</option>
                          <option value="07">Linha 07 - SAÚDE MENTAL</option>
                          <option value="11">Linha 11 - ESPECIALIDADE</option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 text-right">
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary mb-2"
                        >
                          Gerar Relatório
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default withRouter(Producao);
